// WhatsApp examples shown in WhatsAppTip, one builder per record type, so
// the "✅ … created" tip and the detail page's tip always show the same
// commands. Each returns [{ label, message }]. `code` is the record's code
// in the user's language (HERD-0021, LISTA-0003, PROJ-0002…).

export const herdLotTips = (code, t) => [
  { label: t('wat_add_animals_to_lot'), message: `${code}\n1234 m nelore\n5678 f angus` },
  { label: t('wat_query_lot'),          message: code },
];

export const reproLotTips = (code, t) => [
  { label: t('wat_add_animals'), message: `${code}\n1234\n1235` },
  { label: t('wat_query_lot'),   message: code },
];

// A weight lot's examples depend on its tracking method: "Query lot" always,
// plus the one method-specific command ('combination', or a legacy lot with
// no method, shows all three).
export const weightLotTips = (code, method, t) => {
  const all = [
    { key: 'animal',      label: t('wat_add_animal'),   message: `${code} 1234 285kg` },
    { key: 'lot_average', label: t('wat_query_lot'),    message: code },
    { key: 'score',       label: t('wat_record_score'), message: `${code} -2` },
  ];
  const m = method || 'combination';
  return (m === 'combination' ? all : all.filter(tip => tip.key === m || tip.key === 'lot_average'))
    .map(({ label, message }) => ({ label, message }));
};

// A list's first WhatsApp alias (or its name) works in place of the code
// (Trello 4MZZ7pDV), so it's the add-item example when there is one.
export const listTips = (list, code, t) => {
  const example = t('wat_list_item_example');
  const alias = (list.matches || '').split(';').map(s => s.trim()).filter(Boolean)[0];
  const tips = [
    { label: t('wat_add_list_item'), message: `${alias || code} ${example}` },
    { label: t('wat_list_mark_purchased'), message: `${t('wat_list_purchased_keyword')} ${alias || code} ${example}` },
    { label: t('wat_query_list'), message: code },
  ];
  if (list.is_default) {
    tips.push({ label: t('wat_list_shorthand'), message: `${t('list_prefix')} ${example}` });
  }
  return tips;
};

// A project is matched by its first nickname, else its name.
export const projectTips = (project, t) => {
  const nickname = (project.matches || '').split(';').map(s => s.trim()).filter(Boolean)[0]
    || (project.name || '').toLowerCase();
  return [
    { label: t('project_tip_expense'), message: `${t('project_tip_expense_keyword')} 1200 ${nickname}` },
    { label: t('project_tip_income'),  message: `${t('project_tip_income_keyword')} 3000 ${nickname}` },
  ];
};
